export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "assets/js/worker.fetch.a4fdd23a.worker.js");
}
